import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : user.role === "wholesale" ? "/w" : "/s"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const u = await login(f.username, f.password);
      nav(u.role === "admin" ? "/admin" : u.role === "wholesale" ? "/w" : "/s", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden flex-col justify-between bg-[#0F172A] p-12 text-white lg:flex">
        <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)", backgroundSize: "32px 32px" }} />
        <div className="relative flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded bg-blue-600 font-mono font-bold">S</div>
          <span className="text-lg font-bold">SIMS</span>
        </div>
        <div className="relative max-w-md">
          <p className="text-4xl font-bold leading-tight tracking-tight">Every pack issued. Every rupee reconciled.</p>
          <p className="mt-4 text-slate-400">Stock Issue & Salesman Management System — the digital register for daily stock, sales, collections and expenses.</p>
        </div>
        <div className="relative grid grid-cols-3 gap-4 font-mono text-xs text-slate-400">
          <div><p className="text-2xl font-bold text-white">Opening</p>+ Issued ± Transfers</div>
          <div><p className="text-2xl font-bold text-white">− Closing</p>= Packs Sold</div>
          <div><p className="text-2xl font-bold text-white">₹ Recon</p>Cash · GPay · Due</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-up" data-testid="login-form">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Sign in</h1>
            <p className="mt-1 text-sm text-slate-500">Use the login ID given by your admin.</p>
          </div>
          <label className="block space-y-1.5">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-600">Username</span>
            <Input autoFocus autoCapitalize="none" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} className="h-12 text-base" data-testid="login-username-input" />
          </label>
          <label className="block space-y-1.5">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-600">Password</span>
            <Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-12 text-base" data-testid="login-password-input" />
          </label>
          {err && <p className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{err}</p>}
          <Button type="submit" disabled={busy || !f.username || !f.password} className="h-12 w-full text-base" data-testid="login-submit-button">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
